import { BrandLockup } from '@/components/BrandLockup';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * The rail's brand block: the app identity, and the way home.
 *
 * Home is `/dashboard` (spec §27) — the cross-project landing page that now
 * opens the rail. It used to point at the project list, back when `/projects`
 * was the only cross-project page there was; with Dashboard above it, "the
 * top-left title" and "the first row" mean the same place.
 *
 * Both shells mount this, so the monogram, the lockup and the active state can
 * never drift apart between the project console and `/admin`.
 */
export function BrandRailLink({
  active,
  onNavigate,
}: {
  active?: boolean;
  onNavigate?: () => void;
}) {
  const { t } = useTranslation();
  const label = t('nav.home', 'Home');

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild size="lg" isActive={active} tooltip={label}>
          <Link
            to="/dashboard"
            onClick={onNavigate}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            <span
              aria-hidden
              className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-brand text-xs font-bold text-primary-foreground"
            >
              CD
            </span>
            <span className="grid flex-1 text-left leading-tight">
              <BrandLockup />
            </span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
